import React, { useEffect } from "react";
import { Card, Accordion } from "react-bootstrap";

export default function StepPanelTypeDraperyOnly({
  ContextAwareToggle,
  t,
  requiredStep,
  stepSelectedLabel,
  widthCart,
  step5,
  step3A0,
  step6A,
  setStep6A,
  setStep6,
  setExtendedTitle,
  extendedTitle,
  setDeps,
  setCart,
  inputs,
  pageLanguage,
  NextStep,
  modalHandleShow,
  setStep6BHead,
  setStep8,
  setHardwareNextStep,
  tracksList,
  step2A,
  step8,
  step6CHead,
  setStep6CHead,
  setStep6C,
  PopoverStickOnHover,
  popoverThumbnailHover,
  popoverImages,
  step2B,
  step2C,
  setPanelPLWarningTemp,
  step31,
  setStep6DHead,
  setStep6CHead9,
  step3,
  pageLoad,
  windowWidthPanelType,
}) {
  let isShow;
console.log(`windowWidthPanelType`, windowWidthPanelType);
  if (step3 === "true" && step31 === "true") {
    isShow = true;
  } else if (step3 === "true" && step31 === "Track") {
    isShow = true;
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) > 160) {
    isShow = true;
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) < 160) {
    isShow = false;
  } else if (step3 === "false" && step31 === "" && parseInt(windowWidthPanelType) < 160) {
    isShow = false;
  } else if (step3 === "false" && step31 === "" && parseInt(windowWidthPanelType) > 160) {
    isShow = true;
  }
  let textDrapery;
  if (step31 === "true" && step3 === "true" && parseInt(windowWidthPanelType) < 160) {
    textDrapery = t("Drapery Panel Rod Single Panel");
  } else if (step3 === "false" && parseInt(windowWidthPanelType) < 160) {
    textDrapery = t("Drapery Panel Single Panel");
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) < 160) {
    textDrapery = t("Drapery Panel Single Panel");
  } else if (
    step3 === "false" &&
    step31 === "" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Rod"
  ) {
    textDrapery = t("Drapery Panel Rod Single Panel");
  } else if (
    step3 === "false" &&
    step31 === "" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Track"
  ) {
    textDrapery = t("Drapery Panel Track Single Panel");
  } else if (
    step3 === "true" &&
    step31 === "true" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Rod"
  ) {
    textDrapery = t("Drapery Panel Rod Single Panel");
  } else if (
    step3 === "true" &&
    step31 === "false" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Rod"
  ) {
    textDrapery = t("Drapery Panel Rod Single Panel");
  } else {
    textDrapery = t("Drapery Panel Track Single Panel");
  }

  let textDrapery2 = "";

  if (step31 === "true" && step3 === "true" && parseInt(windowWidthPanelType) < 160) {
    textDrapery2 = t("Drapery Panel Rod Single Panel, Right");
  } else if (step3 === "false" && parseInt(windowWidthPanelType) < 160) {
    textDrapery2 = t("Drapery Panel Single Panel, Right");
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) < 160) {
    textDrapery2 = t("Drapery Panel Single Panel, Right");
  } else if (
    step3 === "false" &&
    step31 === "" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Rod"
  ) {
    textDrapery2 = t("Drapery Panel Rod Single Panel, Right");
  } else if (
    step3 === "false" &&
    step31 === "" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Track"
  ) {
    textDrapery2 = t("Drapery Panel Track Single Panel, Right");
  } else if (
    step3 === "true" &&
    step31 === "true" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Rod"
  ) {
    textDrapery2 = t("Drapery Panel Rod Single Panel, Right");
  } else if (
    step3 === "true" &&
    step31 === "false" &&
    parseInt(windowWidthPanelType) > 160 &&
    step5 === "Decorative" &&
    step6CHead === "Rod"
  ) {
    textDrapery2 = t("Drapery Panel Rod Single Panel, Right");
  } else {
    textDrapery2 = t("Drapery Panel Track Single Panel, Right");
  }

  let textDrapery3 = "";

  if (step3 === "true" && step31 === "true" && parseInt(windowWidthPanelType) < 160) {
    textDrapery3 = t("Drapery Panel Rod Pair, Split Draw");
  } else if (step3 === "false" && parseInt(windowWidthPanelType) < 160) {
    textDrapery3 = t("Drapery Panel Pair, Split Draw");
  } else if (step6CHead === "Rod" && parseInt(windowWidthPanelType) > 160) {
    textDrapery3 = t("Drapery Panel Rod Pair, Split Draw");
  } else if (step3 === "true" && step31 === "false" && parseInt(windowWidthPanelType) < 160) {
    textDrapery3 = t("Drapery Panel Pair, Split Draw");
  } else {
    textDrapery3 = t("Drapery Panel Track Pair, Split Draw");
  }

  useEffect(() => {
    // Skip during restore (pageLoad true/undefined); live still clears when width is removed
    if (pageLoad !== false) return;
    if (widthCart === undefined) {
      let tempExtended = { ...extendedTitle };
      tempExtended["6"][0] = [];
      setExtendedTitle(tempExtended);
    }
  }, [widthCart]);

  useEffect(() => {
    if (pageLoad) return;
    let tempExtended = { ...extendedTitle };
    tempExtended["8"] = [];
    tempExtended["8A"] = [];
    tempExtended["8B"] = [];
    tempExtended["8C"] = [];
    setExtendedTitle(tempExtended);
  }, [step6CHead]);

  return (
    <Card>
      <Card.Header>
        <ContextAwareToggle
          eventKey="6"
          stepNum={step5 === "Full"  && step3 === "false" ? t("5") : t("6")}
          stepTitle={t("grommet_step6_Drapery")}
          stepRef="6"
          type="1"
          required={requiredStep["6"]}
          stepSelected={stepSelectedLabel["6"] === undefined ? "" : stepSelectedLabel["6"]}
        />
      </Card.Header>
      <Accordion.Collapse eventKey="6">
        <Card.Body>
          <div
            className={
              widthCart === undefined || step5 === "" || step3A0 === ""
                ? "card_body card_body_info"
                : "noDisplay"
            }
          >
            <div className="card_body_info_header">
              <h1 className="card_body_info_header_title">{t("more_info")}</h1>
            </div>
            <hr />
            <div className="card_body_info_body">
              <p className="card_body_info_text">
                {step2A === ""
                  ? t("panel_type_text1_draperyOnly")
                  : widthCart === undefined && step5 === "" && step3A0 === ""
                  ? t("panel_type_text1_draperyOnly")
                  : widthCart === undefined && step5 !== "" && step3A0 === ""
                  ? t("panel_type_text2_draperyOnly")
                  : widthCart === undefined && step5 !== "" && step3A0 !== ""
                  ? t("panel_type_text3-draperyOnly")
                  : widthCart === undefined && step5 === "" && step3A0 !== ""
                  ? t("panel_type_text4_draperyOnly")
                  : t("panel_type_text5_draperyOnly")}
              </p>
            </div>
            <NextStep currentStep="6" eventKey="8">
              {t("NEXT STEP")}
            </NextStep>
          </div>
          <div
            className={
              widthCart !== undefined && step5 !== ""
                ? "card_body_panel_type special_farsi_card_body"
                : "noDisplay"
            }
          >
            {/* drapery panel type */}
            <div className="card_body card_body_radio Customize_Style_container">
            {parseInt(windowWidthPanelType) > 160  && (
                      <div className="secondary_options_step5">
                        <span className="checkbox_text checkBoxPanelType">{t("title_step8_panel_type")}</span>
                      </div>
                    )}
              <div className="box100" style={{padding: "0 0.4rem"}}>
                <p className="step_selection_title">{t("Drapery Panel Type")}</p>
                <div className={isShow ? "grommet_curtain_button_container grommet_curtain_button_container_separated" : "noDisplay"}>
                  <div className="dk_curtain_symmetric_buttons dk_curtain_symmetric_buttons_separated">
                    <button
                      className={`dk_curtain_symmetric_button_left btn
                     ${step6CHead === "Rod" ? "dk_curtain_symmetric_button_on" : ""}
                     ${step31 === "Track" ? "crossed" : ""}`}
                      onClick={() => {
                        if (step6CHead === "Rod") return;
                        if (parseInt(windowWidthPanelType) > 160 && step8 !== "") {
                          modalHandleShow("panelPLWarning");
                          let tempExtended = { ...extendedTitle };
                          if (step6A === "Pair, Split Draw") {
                            tempExtended["6"][0] = "Drapery Panel  Rod Pair, Split Draw";
                            setExtendedTitle(tempExtended);
                          }
                          setPanelPLWarningTemp({
                            stepValue: "Rod",
                            id: "",
                            cartValue: "",
                            event: undefined,
                          });
                        } else if (step8 === "I Have My Own Hardware") {
                          setHardwareNextStep("9");
                          setStep8("");
                          let tempExtended = extendedTitle;
                          tempExtended["8"] = [];
                          tempExtended["6"].splice(3, 1);
                          setExtendedTitle(tempExtended);
                          setStep6CHead("Rod");
                          setStep6C("");

                          setCart(
                            "",
                            "",
                            "PanelTypeC,Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,"
                          );
                        } else {
                          setStep6CHead("Rod");
                          setCart("", "", "PanelTypeC");
                          let tempExtended = { ...extendedTitle };
                          if (step6A === "Pair, Split Draw") {
                            tempExtended["6"][0] = "Drapery Panel  Rod Pair, Split Draw";
                            tempExtended["6"][2] = "";
                            setExtendedTitle(tempExtended);
                          }
                        }
                      }}
                    >
                          <img
                        src={require("../../Images/icon/Rodicon.svg").default }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <span>{t("Rod")}</span>
                    </button>
                    <button
                      className={`dk_curtain_symmetric_button_right btn ${
                        step6CHead === "Track" ? "dk_curtain_symmetric_button_on" : ""
                      } ${tracksList.length > 0 && step2C !== "Grommet" ? "" : ""}
                      ${step31 === "true" ? "crossed" : ""}  
                      ${step31 === "Track" ? "dk_curtain_symmetric_button_on" : ""}`}
                      onClick={() => {
                        if (step6CHead === "Track") return;
                        if (parseInt(windowWidthPanelType) > 160 && step8 !== "") {
                          modalHandleShow("panelPLWarning");
                          let tempExtended = { ...extendedTitle };
                          if (step6A === "Pair, Split Draw") {
                            tempExtended["6"][0] = "Drapery Panel  Track Pair, Split Draw";
                            setExtendedTitle(tempExtended);
                          }
                          setPanelPLWarningTemp({
                            stepValue: "Track",
                            id: "",
                            cartValue: "",
                            event: undefined,
                          });
                        } else if (step8 === "I Have My Own Hardware") {
                          setHardwareNextStep("9");
                          setStep8("");
                          let tempExtended = extendedTitle;
                          tempExtended["8"] = [];
                          tempExtended["6"].splice(2, 1);
                          setExtendedTitle(tempExtended);
                          setStep6CHead("Track");
                          setStep6BHead("Track");
                          setStep6DHead("Track");
                          setStep6C("");

                          setCart(
                            "",
                            "",
                            "PanelTypeC,Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,"
                          );
                        } else {
                          setStep6CHead("Track");
                          setStep6BHead("Track");
                          setStep6DHead("Track");
                          setStep6CHead9("Track");
                          let tempExtended = { ...extendedTitle };
                          if (step6A === "Pair, Split Draw") {
                            tempExtended["6"][0] = "Drapery Panel  Track Pair, Split Draw";
                            tempExtended["6"][2] = "";
                            setExtendedTitle(tempExtended);
                          }

                          setCart("", "", "PanelTypeC");
                        }
                      }}
                    >
                      <img
                    src={require("../../Images/icon/trackicon.svg").default }
                    className="img-fluid height_auto"
                    alt=""
                  />
                      <span>{t("Track")}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="box100"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "fa" ? "row-reverse" : "row",
                }}
              >
              <div
                className={
                  step6CHead === "Rod"
                    ? parseInt(windowWidthPanelType) <= 160 || step5 === "Decorative"
                      ? "box33 radio_style"
                      : "noDisplay"
                    : "box33 radio_style"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_left.svg").default
                      : require("../../Images/drapery/grommet/panel_type_left.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Single Panel")}
                  value="1"
                  name="step6A"
                  ref-num="6"
                  id="6A1"
                  checked={step6A === "Single Panel"}
                  onChange={(e) => {
                    setStep6A("Single Panel");
                    setStep6("Customize Style Per Curtain");
                    let tempExtended = { ...extendedTitle };
                    tempExtended["6"] = tempExtended["6"] || [];
                    tempExtended["6"][0] = textDrapery;
                    setExtendedTitle(tempExtended);
                    setDeps("", "6A,6");
                    setCart("PanelTypeA", "Single Panel");
                    //   selectChanged(e , 1);
                  }}
                  ref={(ref) => (inputs.current["6A1"] = ref)}
                />
                <label htmlFor="6A1">{t("Single Panel")}</label>
              </div>
            
              <div
                className={
                  step6CHead === "Rod"
                    ? step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 160
                        ? parseInt(windowWidthPanelType) > 320
                          ? "noDisplay"
                          : "box33 radio_style radio_recommended wide_panel_type"
                        : "box33 radio_style"
                      : "box33 radio_style"
                    : "box33 radio_style"
                }
              >
                <img
                  src={
                    step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 160 && step6CHead === "Rod"
                        ? pageLanguage === "fa"
                          ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                          : require("../../Images/drapery/grommet/panel_type_both.svg").default
                        : pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                        : require("../../Images/drapery/grommet/panel_type_both.svg").default
                      : pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                      : require("../../Images/drapery/grommet/panel_type_both.svg").default
                  }
                  className="img-fluid"
                  style={{ height: "13.875rem" }}
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Pair, Split Draw")}
                  value="5"
                  name="step6A"
                  ref-num="6"
                  id="6A5"
                  checked={step6A === "Pair, Split Draw"}
                  onChange={(e) => {
                    setStep6A("Pair, Split Draw");

                    let tempExtended = { ...extendedTitle };
                    tempExtended["6"] = tempExtended["6"] || [];
                    tempExtended["6"][0] = textDrapery3;
                    setExtendedTitle(tempExtended);
                    setDeps("", "6A,6");
                    setCart("PanelTypeA", "Pair, Split Draw");
                    //    selectChanged(e , 1 );
                    if (step5 === "Full" && parseInt(windowWidthPanelType) > 320) {
                      modalHandleShow("panelTypeWarning");
                    }
                  }}
                  ref={(ref) => (inputs.current["6A5"] = ref)}
                />
                <label htmlFor="6A5">{t("Pair, Split Draw")}</label>
                {/* <div className="radio_recommended_text">
                  {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                </div> */}
              </div>
              </div>

              <div
                className={parseInt(windowWidthPanelType) > 320 ? "box100" : "noDisplay"}
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "en" ? "row-reverse" : "row",
                }}
              >
              <div
                className={
                  step6CHead === "Rod"
                    ? step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 320
                        ? "box50 radio_style"
                        : "noDisplay"
                      : "noDisplay"
                    : "noDisplay"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_four.svg").default
                      : require("../../Images/drapery/grommet/panel_type_four.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Four Panel, Split Draw")}
                  value="6"
                  name="step6A"
                  ref-num="6"
                  id="6A7"
                  checked={step6A === "Four Panel, Split Draw"}
                  onChange={(e) => {
                    setStep6A("Four Panel, Split Draw");
                    let tempExtended = extendedTitle;
                    tempExtended["6"] = tempExtended["6"] || [];
                    tempExtended["6"][0] = t("Drapery Four Panel, Split Draw");
                    setExtendedTitle(tempExtended);
                    setDeps("", "6A,6");
                    setCart("PanelTypeA", "Four Panel, Split Draw");
                  }}
                  ref={(ref) => (inputs.current["6A7"] = ref)}
                />
                <label htmlFor="6A7">{t("Four Panel, Split Draw")}</label>
               
              </div>
              <div
                className={
                  step6CHead === "Rod"
                    ? step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 320
                        ? "box50 radio_style"
                        : "noDisplay"
                      : "noDisplay"
                    : "noDisplay"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_three.svg").default
                      : require("../../Images/drapery/grommet/panel_type_three.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Three Panel, Split Draw")}
                  value="6"
                  name="step6A"
                  ref-num="6"
                  id="6A6"
                  checked={step6A === "Three Panel, Split Draw"}
                  onChange={(e) => {
                    setStep6A("Three Panel, Split Draw");
                    let tempExtended = extendedTitle;
                    tempExtended["6"] = tempExtended["6"] || [];
                    tempExtended["6"][0] = t("Drapery Three Panel, Split Draw");
                    setExtendedTitle(tempExtended);
                    setDeps("", "6A,6");
                    setCart("PanelTypeA", "Three Panel, Split Draw");
                    //    selectChanged(e , 1);
                  }}
                  ref={(ref) => (inputs.current["6A6"] = ref)}
                />
                <label htmlFor="6A6">{t("Three Panel, Split Draw")}</label>
                {/* <div className="radio_recommended_text">
                  {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                </div> */}
              </div>
              </div>
            </div>

            <div>
              <NextStep currentStep="6" eventKey="8">
                {t("NEXT STEP")}
              </NextStep>
            </div>
          </div>
          {widthCart !== undefined && step5 !== "" && (
            <div className="accordion_help">
              <div className={`help_container ${pageLanguage === "fa" ? "help_container_fa" : ""}`}>
                <div className="help_column help_left_column">
                  <p className="help_column_header">{t("grommet_panel_type_help_1")}</p>
                  <ul className="help_column_list">
                    <li className="no_listStyle">
                      <span className="popover_indicator">
                        {
                          <PopoverStickOnHover
                            placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                            children={
                              <object
                                className="popover_camera"
                                type="image/svg+xml"
                                data={require("../../Images/public/camera.svg").default}
                              />
                            }
                            component={
                              <div className="clearfix">
                                <div className="popover_image clearfix">
                                  <img
                                    src={
                                      popoverImages["step61"] === undefined
                                        ? require("../../Images/drapery/grommet/single_panel.jpg")
                                        : popoverImages["step61"]
                                    }
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                                <div className="popover_footer">
                                  <span className="popover_footer_title">
                                    {t("grommet_panel_type_help_1")}
                                  </span>
                                  <span className="popover_thumbnails">
                                    <div>
                                      <img
                                        src={require("../../Images/drapery/grommet/single_panel.jpg")}
                                        text="step61"
                                        onMouseEnter={(e) => popoverThumbnailHover(e)}
                                        className="popover_thumbnail_img img-fluid"
                                        alt=""
                                      />
                                    </div>
                                  </span>
                                </div>
                              </div>
                            }
                          />
                        }
                      </span>
                      {t("grommet_panel_type_help_2")}
                    </li>
                    <li>{t("grommet_panel_type_help_3")}</li>
                  </ul>
                </div>
                <div className="help_column help_right_column">
                  <p className="help_column_header">{t("grommet_panel_type_help_4")}</p>
                  <ul className="help_column_list">
                    <li className="no_listStyle">
                      <span className="popover_indicator">
                        {
                          <PopoverStickOnHover
                            placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                            children={
                              <object
                                className="popover_camera"
                                type="image/svg+xml"
                                data={require("../../Images/public/camera.svg").default}
                              />
                            }
                            component={
                              <div className="clearfix">
                                <div className="popover_image clearfix">
                                  <img
                                    src={
                                      popoverImages["step52"] === undefined
                                        ? require("../../Images/drapery/grommet/pair_panel.jpg")
                                        : popoverImages["step52"]
                                    }
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                                <div className="popover_footer">
                                  <span className="popover_footer_title">
                                    {t("grommet_panel_type_help_6")}
                                  </span>
                                  <span className="popover_thumbnails">
                                    <div>
                                      <img
                                        src={require("../../Images/drapery/grommet/pair_panel.jpg")}
                                        text="step52"
                                        onMouseEnter={(e) => popoverThumbnailHover(e)}
                                        className="popover_thumbnail_img img-fluid"
                                        alt=""
                                      />
                                    </div>
                                  </span>
                                </div>
                              </div>
                            }
                          />
                        }
                      </span>
                      {t("grommet_panel_type_help_6")}
                    </li>
                    <li>{t("grommet_panel_type_help_7")}</li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}
